import { render, staticRenderFns } from "./LotteryGamePlay.vue?vue&type=template&id=ce70763a"
import script from "./LotteryGamePlay.vue?vue&type=script&lang=js"
export * from "./LotteryGamePlay.vue?vue&type=script&lang=js"
import style0 from "./LotteryGamePlay.vue?vue&type=style&index=0&id=ce70763a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports